<template>
  <div class="table-title">
    <ToolbarIcons
      type-img="plus"
      @click-icon="addNewUser"
    />
  </div>
  <DataTable
    :value="dataSource"
    data-key="id"
    v-model:filters="filters"
    filter-display="row"
    show-gridlines
    selection-mode="single"
    edit-mode="cell"
    resizable-columns
    state-storage="local"
    paginator
    :rows="7"
    :rows-per-page-options="[7, 10, 20, 50]"
    @row-dblclick="changeUser"
  >
    <Column
      :sortable="true"
      field="IsActive"
      header="Статус"
      :body-style="{'text-align': 'center'}"
      :show-filter-menu="false"
    >
      <template #body="{ data }">
        <i
          class="pi"
          :class="{
            'pi-lock-open text-green-500': data.IsActive,
            'pi-lock text-red-400': !data.IsActive
          }"
        />
      </template>
      <template #filter="{ filterModel, filterCallback }">
        <TriStateCheckbox
          v-model="filterModel.value"
          @change="filterCallback()"
          :binary="true"
          class="p-column-filter"
          :showClear="false"
        />
      </template>
      <!-- <template #filter="{ filterModel, filterCallback }">
        <Dropdown
            v-model="filterModel.value"
            @change="filterCallback()"
            :options="[true, false]"
            placeholder="Все"
            class="p-column-filter"
            :showClear="true"
          >
            <template #option="{ option }">
              <i
                class="pi"
                :class="{
                  'pi-lock-open text-green-500': option,
                  'pi-lock text-red-400': !option
                }"
              />
            </template>
          </Dropdown>
      </template> -->
    </Column>
    <Column
      :sortable="true"
      field="LastName"
      header="Фамилия"
      :show-filter-menu="false"
    >
      <template #filter="{filterModel, filterCallback}">
        <InputText
          type="text"
          v-model="filterModel.value"
          class="p-column-filter"
          placeholder="Поиск"
          @input="filterCallback()"
        />
      </template>
    </Column>
    <Column
      :sortable="true"
      field="FirstName"
      header="Имя"
      :show-filter-menu="false"
      body-style="text-align:center"
    >
      <template #filter="{filterModel, filterCallback}">
        <InputText
          type="text"
          v-model="filterModel.value"
          class="p-column-filter"
          placeholder="Поиск"
          @input="filterCallback()"
        />
      </template>
    </Column>
    <Column
      :sortable="true"
      field="PatronymicName"
      header="Отчество"
      :show-filter-menu="false"
      body-style="text-align:center"
    >
      <template #filter="{filterModel, filterCallback}">
        <InputText
          type="text"
          v-model="filterModel.value"
          class="p-column-filter"
          placeholder="Поиск"
          @input="filterCallback()"
        />
      </template>
    </Column>
    <Column
      :sortable="true"
      field="UserName"
      header="Логин"
      :show-filter-menu="false"
      body-style="text-align:center"
    >
      <template #filter="{filterModel, filterCallback}">
        <InputText
          type="text"
          v-model="filterModel.value"
          class="p-column-filter"
          placeholder="Поиск"
          @keydown.enter="filterCallback()"
        />
      </template>
    </Column>
    <Column
      :sortable="true"
      header="Админ"
      field="IsAdmin"
      :show-filter-menu="false"
      body-style="text-align:center"
    >
      <template #body="{ data }">
        <Checkbox
          v-model="data.IsAdmin"
          :binary="true"
          disabled
        />
      </template>
      <template #filter="{ filterModel, filterCallback }">
        <TriStateCheckbox
          v-model="filterModel.value"
          @change="filterCallback()"
          :binary="true"
          class="p-column-filter"
          :showClear="false"
        />
      </template>
    </Column>
    <Column
      field="Policies"
      :sortable="true"
      header="Полномочия"
      :body-style="{'text-align': 'center'}"
    >
      <template #body="{ data }">
        <span
          v-for="(item, idx) in data.Policies"
          :key="idx"
        >
        {{ item + '; ' }}
      </span>
      </template>
    </Column>
  </DataTable>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Checkbox from 'primevue/checkbox'
import TriStateCheckbox from 'primevue/tristatecheckbox'
import ToolbarIcons from '@/components/icons/ToolbarIcons.vue'

import { FilterMatchMode } from 'primevue/api'

export default {
  name: 'RolesListTable',
  components: {
    DataTable,
    Column,
    InputText,
    Checkbox,
    TriStateCheckbox,
    ToolbarIcons
  },
  setup () {
    const store = useStore()

    const filters = ref({
      IsActive: { value: null, matchMode: FilterMatchMode.EQUALS },
      FirstName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      LastName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      Login: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      PatronymicName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      UserName: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      IsAdmin: { value: null, matchMode: FilterMatchMode.EQUALS }
    })

    const rolesFilter = ref([
      {
        id: 1,
        name: 'Пользователь',
        active: true
      },
      {
        id: 2,
        name: 'Администратор',
        active: false
      }
    ])

    const dataSource = computed(() => {
      return store.getters.getUsers
    })

    const addNewUser = () => {
      store.dispatch('setGetUserForm', 0)
      router.push(`roles/${0}`)
    }

    const changeUser = (e) => {
      router.push(`roles/${e.data.Id}`)
    }

    return {
      dataSource,
      filters,
      rolesFilter,
      addNewUser,
      changeUser
    }
  }
}
</script>

<style>
.p-dropdown .p-inputtext {
  border: none;
  display: flex;
  align-items: center;
}

.p-dropdown-panel .p-dropdown-items {
  padding: 0.5rem 0;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  color: #495057;
  background: #E3F2FD;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  margin: 0;
  padding: 0.5rem 1rem;
  border: 0 none;
  color: #495057;
  background: transparent;
  transition: box-shadow 0.2s;
  border-radius: 0;
}

</style>

<style lang="scss" scoped>
.table-title {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 15px 0;
  margin-bottom: 25px;
  color: #000000;
  font-size: 26px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.52px;
}
.text-green-500 {
  color: var(--green-500);
}

.text-red-400 {
  color: var(--red-400);
}

.p-checkbox.p-checkbox-checked.p-checkbox-disabled {
  cursor: default;
  background-color: #1ba6da;
  border-radius: 4px;
}

:deep(.p-hidden-space) {
  display: none !important;
}

:deep(.p-datatable-thead) {
  th {
    font-weight: 400 !important;
    font-size: 16px !important;
    color: #787878 !important;
    background-color: #E6E6E6 !important;
    border-right: 1px solid #787878 !important;
    border-bottom: none !important;

    &:last-child {
      border-right: none !important;
    }
  }
}
:deep(.p-datatable-tbody) {
  td {
    font-weight: 400 !important;
    font-size: 16px !important;
    color: #000000 !important;
    border: 1px solid #E6E6E6 !important;
  }
  tr.p-highlight {
    background: #DEDEDE !important;
    &:focus, &:active {
      outline: none !important;
      border: none !important;
    }
  }
}
:deep(.p-inputtext) {
  border: 1px solid #000000;
  width: 100% !important;
  padding: 6px 12px !important;
  &:hover {
    border-color: #000000 !important;
  }
  &:focus {
    box-shadow: none !important;
    border-color: #000000 !important;
  }
}
:deep(.p-dropdown) {
  border: 1px solid #C8C8C8 !important;
  background-color: #F5F5F5 !important;
  /* Состояние фокуса */
  &.p-focus {
    box-shadow: none !important;
    outline: none !important;
    border-color: #000000 !important;
  }
  /* Состояние ховера */
  &:not(.p-disabled):hover {
    border-color: #000000 !important;
  }
  /* Внутренние элементы */
  .p-dropdown-label {
    &:focus {
      box-shadow: none !important;
      outline: none !important;
    }
  }
  /* Триггер (стрелка) */
  .p-dropdown-trigger {
    &:focus {
      outline: none !important;
    }
  }
}

:deep(.header-with-filter) {
  width: 100%;
  .p-dropdown {
    position: relative !important;
    width: 100% !important;
    min-width: 100% !important;
    font-size: 16px !important;
    .p-dropdown-trigger {
      position: absolute;
      right: 0;
      top: calc(50% - 9px);
    }
  }
  .p-inputtext {
    width: 100% !important;
    min-width: 100% !important;
    font-size: 16px !important;
  }
}
:deep(.p-dropdown-item) {
  .p-highlight {
    background-color: #DEDEDE !important;
    &:focus, &:active {
      outline: none !important;
      border: none !important;
    }
  }
}
:deep(.p-paginator) {
  background-color: #F5F5F5;
  .p-highlight {
    background-color: #00ABEC !important;
    color: #ffffff !important;
  }
  .p-paginator-page {
    color: #000000;
  }

  .p-dropdown-item {
    width: 100%;
    .p-highlight {
      background: #DEDEDE !important;
      &:focus, &:active {
        outline: none !important;
        border: none !important;
      }
    }
  }
}
:deep(.p-sortable-column-icon) {
  display: none !important;
}
:deep(.p-sortable-column) {
  position: relative;
  .p-column-title {
    &::after {
      content: '';
      display: inline-block;
      width: 16px;
      height: 20px;
      margin-left: 5px;
      background-image: url('/public/img/icons/SortIcon.svg');
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
    }
  }
}

:deep(.p-inputswitch-checked) {
  .p-inputswitch-slider {
    background: #00ABEC !important;
  }
}
:deep(.p-inputswitch-slider) {
  background: #E6E6E6!important;
  height: 12px;
}
:deep(.p-inputswitch) {
  .p-inputswitch-slider {

    &::before {
      margin-top: -0.7rem !important;
      border: 2px solid #00ABEC !important;
    }

    &.p-highlight {
      background: #00ABEC !important; // Цвет при включённом состоянии (checked)
    }
  }
}

:deep(.p-filter-column) {
  text-align: center !important;
}

:deep(.p-checkbox-box.p-highlight) {
  background-color: #00ABEC !important;
  border-color: #00ABEC !important;
}
:deep(.p-checkbox .p-checkbox-box) {
  border-radius: 5px;
  border: 2px solid #787878;
}

:deep(.p-row-editor-save .p-row-editor-save-icon),
:deep(.p-row-editor-cancel .p-row-editor-cancel-icon) {
  fill: #787878 !important;
}

:deep(.p-row-editor-save .p-row-editor-save-icon path),
:deep(.p-row-editor-cancel .p-row-editor-cancel-icon path) {
  fill: #787878 !important;
}
:deep(.p-row-editor-save),
:deep(.p-row-editor-cancel) {
  border: 2px solid #787878 !important;
  width: 25px !important;
  height: 25px !important;

  &:hover {
    border-color: #00ABEC !important;
    path {
      fill: #00ABEC !important;
    }
  }

  &:focus {
    box-shadow: none !important;
  }
}

</style>
